import { render, staticRenderFns } from "./ContactPopover.vue?vue&type=template&id=b9bba7b4&scoped=true&"
import script from "./ContactPopover.vue?vue&type=script&lang=js&"
export * from "./ContactPopover.vue?vue&type=script&lang=js&"
import style0 from "./ContactPopover.vue?vue&type=style&index=0&id=b9bba7b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9bba7b4",
  null
  
)

export default component.exports